/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseManageTicket } from '../../models/api-response-manage-ticket';
import { ManageTicket } from '../../models/manage-ticket';

export interface CreateManageTicket$Params {
  requestId: string;
  canal: string;
      body: ManageTicket
}

export function createManageTicket(http: HttpClient, rootUrl: string, params: CreateManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicket>> {
  const rb = new RequestBuilder(rootUrl, createManageTicket.PATH, 'post');
  if (params) {
    rb.query('requestId', params.requestId, {});
    rb.query('canal', params.canal, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseManageTicket>;
    })
  );
}

createManageTicket.PATH = '/v1/api/ui/manage-ticket/create';
